import React, { useEffect, useState, useRef } from 'react'
import { Link } from "react-router-dom";
import { getDeals } from "../../functions/deal";
import laptop from "../../images/laptop.png";
import moment from 'moment'
import WeeklyPamphlet from "../../images/WeeklyPamphlet.jpg"
import C7ZTQ from "../../images/C7ZTQ.jpg"
import contestPad from "../../images/contestPad.jpg"
import careerPad from "../../images/careerPad.jpg"
import referPad from "../../images/referPad.jpg"
import ItalianFood from "../../images/ItalianFood.jpg"
import nintyPic from "../../images/nintyPic.jpg"
import Cocktail from "../../images/Cocktail.jpg"
import ChineseFood from "../../images/ChineseFood.jpg"


const DealCategory = () => {

    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(false);

    const [timerHours, setTimerHours] = useState('00')
    const [timerMinutes, setTimerMinutes] = useState('00')
    const [timerSeconds, setTimerSeconds] = useState('00')

    let interval = useRef();

    const startTimer = () => {
        const countdownDate = new Date(`${moment().startOf('day').add(1, 'day').format('LL')} 12:00:00`).getTime()

        interval = setInterval(() => {
            const now = new Date().getTime();

            const distance = countdownDate - now

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (distance < 0) {
                clearInterval(interval.current)
            } else {
                setTimerHours(hours);
                setTimerMinutes(minutes);
                setTimerSeconds(seconds)
            }

        }, 1000)
    }

    useEffect(() => {
        loadAllDeals();
    }, []);

    const loadAllDeals = () => {
        setLoading(true);
        getDeals().then((res) => {
            setDeals(res.data);
            setLoading(false);
        });
    };

    const handleView = () => {
        console.log('pressed', moment().startOf('day').add(1, 'day').format('LL'));
    }

    return (
        <div>
            <div>
                <div className="simple-tile-carousel simple-tile-carousel--max">
                    <div className="simple-tile-carousel_content simple-tile-carousel_content--small">
                        <div className="pdl-carousel_container pdl-carousel_container--mobile">
                            <div className="simple-tile-list">
                                <Link to="/pages/bulk-store">
                                    <div className>
                                        <div className="simple-tile-list_item">
                                            <div className="simple-tile_row spyglass-nav-group_wrapper">
                                                <div aria-label="30% off Nature's Promise steaks and ground beef." tabIndex={0} role="link" className="simple-tile_box">
                                                    <div className="simple-content-tile_image-container-new"><img src="https://res.cloudinary.com/dk6m0wics/image/upload/v1647549025/Button_1_hvlhet.jpg" alt="Grilled steak on a cutting board" className="simple-content-tile_image-neww" /></div>
                                                    <div className="simple-tile_copy-container select-text">
                                                        <p style={{ color: 'black' }}>Buy More Pay Less</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/passport">
                                    <div className>
                                        <div className="simple-tile-list_item">
                                            <div className="simple-tile_row spyglass-nav-group_wrapper">
                                                <div aria-label="30% off Nature's Promise steaks and ground beef." tabIndex={0} role="link" className="simple-tile_box">
                                                    <div className="simple-content-tile_image-container-new"><img src="https://res.cloudinary.com/dk6m0wics/image/upload/v1647549025/Passport_Circle_1_jfs4ea.jpg" alt="Grilled steak on a cutting board" className="simple-content-tile_image-neww" /></div>
                                                    <div className="simple-tile_copy-container select-text">
                                                        <p style={{ color: 'black' }}>Shop the World</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/recipes">
                                    <div className>
                                        <div className="simple-tile-list_item">
                                            <div className="simple-tile_row spyglass-nav-group_wrapper">
                                                <div aria-label="30% off Nature's Promise steaks and ground beef." tabIndex={0} role="link" className="simple-tile_box">
                                                    <div className="simple-content-tile_image-container-new"><img src={C7ZTQ} alt="Grilled steak on a cutting board" className="simple-content-tile_image-neww" /></div>
                                                    <div className="simple-tile_copy-container select-text">
                                                        <p style={{ color: 'black' }}>Cook World Recipes</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>

                                <Link to="/optima-referral">
                                    <div className="simple-tile-list_item">
                                        <div className="simple-tile_row spyglass-nav-group_wrapper">
                                            <div aria-label="Save $5 when you spend $15 on health & beauty." tabIndex={0} role="link" className="simple-tile_box">
                                                <div className="simple-content-tile_image-container-new"><img src={referPad} alt="Old Spice, Secret, Suave, and Dove products" className="simple-content-tile_image-neww" /></div>
                                                <div className="simple-tile_copy-container select-text">
                                                    <p style={{ color: 'black' }}>Refer a friend & Earn</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to='/career'>
                                    <div className="simple-tile-list_item">
                                        <div className="simple-tile_row spyglass-nav-group_wrapper">
                                            <div aria-label="Satisfy your sweet tooth all summer long." tabIndex={0} role="link" className="simple-tile_box">
                                                <div className="simple-content-tile_image-container-new"><img src={careerPad} className="simple-content-tile_image-neww" /></div>
                                                <div className="simple-tile_copy-container select-text">
                                                    <p style={{ color: 'black' }}>Work with us!</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DealCategory
